/**
 * External Dependencies
 */

 import 'jquery';
 import Swiper from 'swiper/bundle';
 var $ = require('jquery');
 var Masonry = require('masonry-layout');
 var imagesLoaded = require('imagesloaded');
 import * as basicScroll from 'basicscroll';
 import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
 import "@lottiefiles/lottie-player";

 /**
  * Internal Dependencies
  */
 import initSmoothScroll from './smooth-scroll';
import initTopNav from './top-nav';
import initHomeHeader from './home-header';
import initFeaturedHero from './featured-hero';
import initImageTextHero from './image-text-hero';
import initQuiz from './quiz';
import initAudiences from './audiences';
import initUsps from './usps';
import initStats from './stats';
import initContactWidget from './contact-widget';
import initProjectCards from './project-cards';
import initEpisodes from './episodes';
import initVideoModal from './video-modal';
import initShowreel from './showreel';
import initVideoScale from './video-scale';
import initPlayer from './player';
import initCursorLabel from './cursor-label';
import initLogoWall from './logo-wall';
import initTabs from './tabs';
import initProjectsFilter from './projects-filter';
import initVacancyHero from './vacancy-hero';
import initVacancyApplyBar from './vacancy-apply-bar';
import initVacancyBenefits from './vacancy-benefits';
import initVacancySteps from './vacancy-steps';
import initProjectHero from './project-hero';
import initSingleHero from './single-hero';
import initNewsFilter from './news-filter';
import initFaqFilter from './faq-filter';
import initContactMarquee from './contact-marquee';
import initGradientWaveText from './gradient-wave-text';
import initHistoryArc from './history-arc';
import initMomentumBasedHover from './momentum-hover';

 $(document).ready(function() {
  // Uitklapbare topnav (logo + hamburger bovenin).
  initSmoothScroll();
  initTopNav();
  initHomeHeader();
  initFeaturedHero();
  initImageTextHero();
  initQuiz();
  initAudiences();
  initUsps();
  initStats();
  initContactWidget();
  initProjectCards();
  initEpisodes();
  initVideoModal();
  initShowreel();
  initVideoScale();
  initPlayer();
  initCursorLabel();
  initLogoWall();
  initTabs();
  initProjectsFilter();
  initVacancyHero();
  initVacancyApplyBar();
  initVacancyBenefits();
  initVacancySteps();
  initProjectHero();
  initSingleHero();
  initNewsFilter();
  initFaqFilter();
  initContactMarquee();
  initGradientWaveText();
  initHistoryArc();
  initMomentumBasedHover();

  // // CUSTOM CURSOR
  // const cursor = document.querySelector('.cursor');
  // $(document).mousemove(function(d){
  //   cursor.style.top = d.clientY + 'px';
  //   cursor.style.left = d.clientX + 'px';
  // });

  // init Masonry
  if ( $('.images__grid').length) {
    var grid = document.querySelector('.images__grid');

    var msnry = new Masonry( grid, {
      itemSelector: '.images__item',
    });

    imagesLoaded( grid ).on( 'progress', function() {
      msnry.layout();
    });
  }

  $('.swiper-container, .swiper-images, .services__loop, .imageswiper-container, .swiper-services').mouseover(
    function() {
      // Staat de slider op slot omdat alles er al in past, dan valt er niets te slepen
      // en hoort de sleepcursor er ook niet te zijn.
      var swiper = (this.swiper ? this : this.querySelector('.swiper-initialized') || {}).swiper;

      if (swiper && swiper.isLocked) {
        return;
      }

      $('body').attr('data-cursor', 'drag');
    }
  ).mouseleave(
    function() {
      $('body').attr('data-cursor', 'normal');
    }
  );

  var Swipes = new Swiper('.swiper-container', {
    loop: false,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 24
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 24
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32
      },
    },
    parallax: true,
    preloadImages: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: '.pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  var Swipes = new Swiper('.swiper-images', {
    effect: 'cards',
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loop: false,
    breakpoints: {
      320: {
        slidesPerView: 1
      },
    },
    preloadImages: true,
  });

  var swiper = new Swiper(".swiper--slider", {
    effect: "cards",
    grabCursor: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var Swipes = new Swiper('.swiper-services:not(.swiper-services--loop)', {
    loop: false,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 24
      },
    },
    parallax: true,
    preloadImages: true,
    pagination: {
      el: '.pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  // 'Wat we nog meer doen' onder een dienst: op desktop drie kaarten naast elkaar.
  // Zijn het er drie of minder, dan zet watchOverflow (standaard aan) de slider op slot
  // en verbergt Swiper de bolletjes -- het blijft dan een stilstaand raster van drie.
  var Swipes = new Swiper('.swiper-services--loop', {
    loop: false,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 24
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32
      },
    },
    parallax: true,
    preloadImages: true,
    pagination: {
      el: '.pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  var Swipes = new Swiper('.imageswiper-container', {
    loop: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
    },
    parallax: true,
    preloadImages: true,
    pagination: {
      el: '.pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  // Swipes.on( 'sliderMove', function( event ) {
  //   cursor.style.top = event.originalEvent.y + 'px';
  //   cursor.style.left = event.originalEvent.x + 'px';
  // });

  setTimeout(function() {
    document.querySelectorAll('.basic-image').forEach((elem) => {
      basicScroll.create({
        elem: elem,
        from: 'center-center',
        to: 'bottom-bottom',
        direct: true,
        props: {
          '--scaleX': {
            from: '1',
            to: '1.5',
          },
          '--scaleY': {
            from: '1',
            to: '1.5',
          },
        },
      }).start()
    })

    // document.querySelectorAll('.basic-opacity').forEach((elem) => {
    //   basicScroll.create({
    //     elem: elem,
    //     from: 'center-center',
    //     to: 'bottom-bottom',
    //     direct: true,
    //     props: {
    //       '--opacity': {
    //         from: '0.4',
    //         to: '0.8',
    //       },
    //     },
    //   }).start()
    // })

    document.querySelectorAll('.move-top').forEach((elem) => {
      basicScroll.create({
        elem: elem,
        from: 'bottom-bottom',
        to: 'top-top',
        direct: true,
        props: {
          '--translateY': {
            from: '0',
            to: '-50%',
          },
        },
      }).start()
    })

    document.querySelectorAll('.move-left').forEach((elem) => {
      basicScroll.create({
        elem: elem,
        from: 'bottom-bottom',
        to: 'top-top',
        direct: true,
        props: {
          '--translateX': {
            from: '0',
            to: '-100%',
          },
        },
      }).start()
    })

    document.querySelectorAll('.move-right').forEach((elem) => {
      basicScroll.create({
        elem: elem,
        from: 'bottom-bottom',
        to: 'top-top',
        direct: true,
        props: {
          '--translateX': {
            from: '0',
            to: '100%',
          },
        },
      }).start()
    })
}, 150);

// active images in viewport
  var active_images = 4;

  // time image change
  var fader_delay   = 3000;

  // setup image urls
  var images = [];

  // read img from html
  $('#logofader img').each(function(index) {

    // add src to array
    // images.push($( this ).attr('src'))
    images.push($(this).data("src") );

    // remove from dom
    $( this ).remove();
  });

  // add initial active images to active array
  var images_active = images.splice(0, active_images);
  // add initial images to viewport
  for (var i = 0; i < images_active.length; i++) {
    $('#logofader').prepend($(`
      <div class="brand w-full relative">
          <div class="aspect-video"></div>
          <div class="ease-in-out duration-300 absolute inset-0 flex items-center justify-center">
            <div class="p-4 lg:p-8 xl:p-12 w-full">
              <img class="brand__image w-full h-full object-contain z-10 relative max-h-[4rem] max-w-[10rem] mx-auto" src="${images_active[i]}">
            </div>
          </div>
        </div>
    `));
  }

  // var loop = runLoop();

  // function runLoop() {
  //   return window.setInterval(function(){
  //     // get random active image from array
  //     var randomActive = images_active[Math.floor(Math.random()*images_active.length)];

  //     // get random hidden image from array
  //     var randomHidden = images[Math.floor(Math.random()*images.length)];


  //     // loop trough active images
  //     $('#logofader img').each(function(index) {

  //       // find the random image
  //       if($( this ).prop('src') == randomActive) {

  //         // replace the src with the new url
  //         $(this).fadeOut(400, function() {
  //             $( this ).prop('src', randomHidden);
  //         })

  //         .fadeIn(400);
  //         // $( this ).attr('src', randomHidden);

  //       }
  //     });

  //     // call swapimage for keeping arrays up to date
  //     swapImage(randomActive, randomHidden);
  //   }, fader_delay);
  // }


  // function swapImage(urlActive, urlHidden) {


  //   // find active url and remove it from array
  //   images_active = images_active.filter((element) => {
  //     if(element != urlActive)
  //       return true
  //     else
  //       return false
  //   });

  //   // find hidden url and remove it from array
  //   images = images.filter((element) => {
  //     if(element != urlHidden)
  //       return true
  //     else
  //       return false
  //   });

  //   // add urls to arrays
  //   images.push(urlActive);
  //   images_active.push(urlHidden);

  // }

  // window.addEventListener('focus', function() {
  //   // browser active do loop
  //   loop = runLoop();
  // },false);

  // window.addEventListener('blur', function() {
  //     // browser gone stop loop
  //     window.clearInterval(loop);
  // },false);

  // ADD SPAN TO BASIC BUTTON
  jQuery('.wp-block-button__link').wrapInner('<span></span>');

});
